import { IAsyncData } from '../../shared/models/base.model';
import produce from 'immer';
import * as fromActions from './vehicle.actions';
import * as fromAdapter from './vehicle.adapter';

export interface IInventoryVehicle extends IAsyncData {
    data: any;
}

export interface VehiclesState extends IAsyncData {
    vehicles: IInventoryVehicle,
    status:any,
    allVehicles : IInventoryVehicle,
    count: number,
    bulkStatusLoading: boolean
}

const initialVehicleData = {
    data: undefined,
    loading: false,
    loaded: false,
    error: ''
  };

const initialState: VehiclesState = {
    vehicles: initialVehicleData,
    status :{},
    allVehicles : initialVehicleData,
    count: 0,
    bulkStatusLoading: false,
    loading: false,
    loaded: false,
    error: ''
};

export function vehiclesReducer(state: VehiclesState = initialState,
    action: fromActions.VehiclesActions): VehiclesState {

    switch (action.type) {
        case fromActions.VehiclesActionTypes.ADD_VEHICLE_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.AddVehicleSuccess ? action.payload.vehicle : '';
                draftState.vehicles.data.push(payload);
                draftState.allVehicles.data.push(payload);
                draftState.count = state.count + 1
            });
        }
        case fromActions.VehiclesActionTypes.ADD_VEHICLE_FAILURE: {
            return produce(state, draftState => {
                draftState.error = action instanceof fromActions.AddVehicleFailure ? action.payload.error : '';
            });
        }

        case fromActions.VehiclesActionTypes.LOAD_VEHICLES:{
            return produce(state, draftState => {
                draftState.vehicles = {
                    data : undefined,
                    loading : true,
                    loaded: false,
                    error : ''
                }
                draftState.count = 0
            })
        }

        case fromActions.VehiclesActionTypes.LOAD_VEHICLES_SUCCESS:{
            return produce(state, draftState => {
                draftState.vehicles = {
                    data : action instanceof fromActions.LoadVehiclesSuccess ? action.payload.vehicles.vehicles : {},
                    loading : false,
                    loaded : true,
                    error : ''
                }
                draftState.count = action instanceof fromActions.LoadVehiclesSuccess ? action.payload.vehicles.allVehiclesCount : 0
            })
        }

        case fromActions.VehiclesActionTypes.LOAD_VEHICLES_FAILURE:{
            return produce(state, draftState => {
                draftState.vehicles = {
                data : undefined,
                loading : false,
                loaded : false,
                error : action instanceof fromActions.LoadVehiclesFailure ? action.payload.error : ''
                }
            })
        }

        case fromActions.VehiclesActionTypes.FETCH_VEHICLES_FROM_SOURCE:
        case fromActions.VehiclesActionTypes.LOAD_ALL_VEHICLES:{
            return produce(state, draftState => {
                draftState.allVehicles = {
                    data: undefined,
                    loading : true,
                    loaded : false,
                    error : ''
                }
                draftState.vehicles = {
                    data : undefined,
                    loading : true,
                    loaded: false,
                    error : ''
                }
                draftState.count = 0
            })
        }

        case fromActions.VehiclesActionTypes.LOAD_ALL_VEHICLES_SUCCESS:{
            return produce(state, draftState => {
                const vehicles = action instanceof fromActions.LoadAllVehiclesSuccess ? action.payload.vehicles : [];
                draftState.allVehicles = {
                    data : vehicles,
                    loading : false,
                    loaded : true,
                    error: ''
                }
                draftState.vehicles = {
                    data : vehicles,
                    loading : false,
                    loaded : true,
                    error : ''
                }
                draftState.count = vehicles?.length;
            })
        }

        case fromActions.VehiclesActionTypes.LOAD_ALL_VEHICLES_FAILURE:{
            return produce(state, draftState => {
                draftState.allVehicles = {
                    data: undefined,
                    loading : false,
                    loaded : false,
                    error : action instanceof fromActions.LoadAllVehiclesFailure ? action.payload.error : ''
                }
            })
        }

                case fromActions.VehiclesActionTypes.UPDATE_BULK_VEHICLE_STATUS: {
                        return {
                            ...state,
                            bulkStatusLoading: true
                        };
                }

        case fromActions.VehiclesActionTypes.UPDATE_NVI_STATUS_FAILURE: {
            return produce(state, draftState => {
                draftState.error = action instanceof fromActions.UpdateNVIStatusFailure ? action.payload.error : '';
            });
        }

        case fromActions.VehiclesActionTypes.UPDATE_NVI_STATUS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateNVIStatusSuccess ? action.payload.vehicle : undefined;
                draftState.vehicles.data.forEach((obj, index )=> {
                    if(obj.vin === payload.vin){
                      draftState.vehicles.data[index] = {...state.vehicles.data[index],...payload};
                    }
                  })
                  draftState.allVehicles.data.forEach((obj, index )=> {
                    if(obj.vin === payload.vin){
                      draftState.allVehicles.data[index] = {...state.allVehicles.data[index],...payload};
                    }
                  })
            });
        }

        case fromActions.VehiclesActionTypes.UPDATE_UVI_STATUS_FAILURE: {
            return produce(state, draftState => {
                draftState.error = action instanceof fromActions.UpdateUVIStatusFailure ? action.payload.error : '';
            });
        }

        case fromActions.VehiclesActionTypes.UPDATE_UVI_STATUS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateUVIStatusSuccess ? action.payload.vehicle : undefined;
                draftState.vehicles.data.forEach((obj, index )=> {
                    if(obj.vin === payload.vin){
                      draftState.vehicles.data[index] = {...state.vehicles.data[index],...payload};
                    }
                  })
                  draftState.allVehicles.data.forEach((obj, index )=> {
                    if(obj.vin === payload.vin){
                      draftState.allVehicles.data[index] = {...state.allVehicles.data[index],...payload};
                    }
                  })
            });
        }

        case fromActions.VehiclesActionTypes.UPDATE_BULK_VEHICLE_STATUS_SUCCESS: {
            return produce(state, draftState => {
                draftState.bulkStatusLoading = false;
                const payload = action instanceof fromActions.UpdateBulkVehicleStatusSuccess ? action.payload : undefined;
                const records = payload?.records || [];
                const requestedVehicles = payload?.requestedVehicles || [];

                const mergeVehicle = (vehicle: any) => {
                    const updatedRecord = records.find(record => {
                        if (record?.unitId && vehicle?.unitId) {
                            return `${record.unitId}` === `${vehicle.unitId}`;
                        }

                        return !!record?.vin && record.vin === vehicle?.vin;
                    });

                    if (updatedRecord) {
                        return { ...vehicle, ...updatedRecord };
                    }

                    const requestedVehicle = requestedVehicles.find(requested => {
                        if (requested?.unitId && vehicle?.unitId) {
                            return `${requested.unitId}` === `${vehicle.unitId}`;
                        }

                        return !!requested?.vin && requested.vin === vehicle?.vin;
                    });

                    return requestedVehicle ? { ...vehicle, status: requestedVehicle.status } : vehicle;
                };

                draftState.vehicles.data = draftState.vehicles.data?.map(vehicle => mergeVehicle(vehicle));
                draftState.allVehicles.data = draftState.allVehicles.data?.map(vehicle => mergeVehicle(vehicle));
            });
        }

        case fromActions.VehiclesActionTypes.UPDATE_BULK_VEHICLE_STATUS_FAILURE: {
            return {
              ...state,
              bulkStatusLoading: false,
              error: action instanceof fromActions.UpdateBulkVehicleStatusFailure ? action.payload.error : state.error
            };
        }

        case fromActions.VehiclesActionTypes.UPDATE_VEHICLE_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateVehicleSuccess ? action.payload.vehicle : undefined;
                draftState.vehicles.data.forEach((obj, index )=> {
                    if(obj.vin === payload.vin){
                      draftState.vehicles.data[index] = {...state.vehicles.data[index],...payload};
                    }
                  })
                  draftState.allVehicles.data.forEach((obj, index )=> {
                    if(obj.vin === payload.vin){
                      draftState.allVehicles.data[index] = {...state.allVehicles.data[index],...payload};
                    }
                  })
            });
        }
        case fromActions.VehiclesActionTypes.UPDATE_VEHICLE_FAILURE: {
            return produce(state, draftState => {
                draftState.error = action instanceof fromActions.UpdateVehicleFailure ? action.payload.error : '';
            });
        }

        case fromActions.VehiclesActionTypes.DELETE_VEHICLE_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.DeleteVehicleSuccess ? action.payload : undefined;
                const deletedVehicles = payload.requestedVehicles.filter(x=> !x?.nextTestDriveDate).map(x=> x.vin);
                const formattedResponse = fromAdapter.formatDeleteResponse(payload.response);
                draftState.vehicles.data = draftState.vehicles.data.filter(a => !deletedVehicles.includes(a.vin) );
                draftState.vehicles.data.forEach((obj, index )=> {
                    if(formattedResponse[obj.vin]){
                      draftState.vehicles.data[index] = {...state.vehicles.data[index], ...formattedResponse[obj.vin][0]};
                    }
                  })
                draftState.allVehicles.data = draftState.allVehicles.data.filter(a => !deletedVehicles.includes(a.vin) );
                draftState.count = state.count - deletedVehicles?.length
            });
        }
        case fromActions.VehiclesActionTypes.DELETE_VEHICLE_FAILURE: {
            return produce(state, draftState => {
                draftState.error = action instanceof fromActions.DeleteVehicleFailure ? action.payload.error : '';
            });
        }

        case fromActions.VehiclesActionTypes.LOAD_SEARCH_VEHICLES: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadSearchVehicles ? action.payload : null;
                draftState.vehicles.data = fromAdapter.getFilteredVehicles(state.allVehicles.data, payload.searchConfig, payload.view);
            });
        }

          case fromActions.VehiclesActionTypes.LOAD_SYNC_STATUS_SUCCESS: {
            return {
              ...state,
              status: action instanceof fromActions.LoadSyncStatusSuccess ? action.payload.status : null
            };
          }
          case fromActions.VehiclesActionTypes.UPDATE_FROM_CRM_SUCCESS: {
            return {
                ...state,
                status: action instanceof fromActions.UpdateFromCrmSuccess ? action.payload.status : null
            };
          }
          case fromActions.VehiclesActionTypes.UPDATE_FROM_CRM_FAILURE: {
            return {
                ...state,
                status: action instanceof fromActions.UpdateFromCrmFailure ? action.payload.error : '' 
              };
          }
          case fromActions.VehiclesActionTypes.LOAD_SYNC_STATUS_FAILURE: {
            return {
              ...state,
              status: action instanceof fromActions.LoadSyncStatusFailure ? action.payload.error : '' 
            };
          }

        case fromActions.VehiclesActionTypes.RESTORE_VEHICLE_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.RestoreVehicleSuccess ? action.payload : undefined;
                draftState.vehicles.data.forEach((obj, index )=> {
                    if(payload.vehicles.findIndex(x=> obj.vin === x) !== -1){
                      draftState.vehicles.data[index] = {...state.vehicles.data[index], status: true, expiredAt: ''};
                    }
                  })
                  draftState.allVehicles.data.forEach((obj, index )=> {
                    if(payload.vehicles.findIndex(x=> obj.vin === x) !== -1){
                      draftState.allVehicles.data[index] = {...state.allVehicles.data[index], status: true, expiredAt: ''};
                    }
                  })
            });
        }

        case fromActions.VehiclesActionTypes.RESTORE_VEHICLE_FAILURE: {
            return produce(state, draftState => {
                draftState.error = action instanceof fromActions.RestoreVehicleFailure ? action.payload.error : '';
            });
        }

        case fromActions.VehiclesActionTypes.FETCH_VEHICLES_FROM_SOURCE_SUCCESS: {
            return produce(state, draftState => {
                const vehicles = action instanceof fromActions.FetchVehiclesBasedOnSourceSuccess ? action.payload.vehicles : [];
                draftState.allVehicles = {
                    data : vehicles,
                    loading : false,
                    loaded : true,
                    error: ''
                }
                draftState.vehicles = {
                    data : vehicles,
                    loading : false,
                    loaded : true,
                    error : ''
                }
                draftState.count = vehicles.length;
            })
        }

        case fromActions.VehiclesActionTypes.FETCH_VEHICLES_FROM_SOURCE_FAILURE: {
            return produce(state, draftState => {
                draftState.vehicles = {
                    data: undefined,
                    loading : false,
                    loaded : false,
                    error : action instanceof fromActions.FetchVehiclesBasedOnSourceFaliure ? action.payload.error : ''
                }
            });
        }

        case fromActions.VehiclesActionTypes.RESET_VEHICLE_STATE: {
            return initialState;
        }

        default:
            return state;
    }
}
